import { Box, useBreakpointValue } from "@chakra-ui/react";
import { useSession } from "next-auth/react";
import Router from "next/router";

import { LogoOfNoah, LogoOfNoahZoey } from "design_system/icons";
import { config } from "src/config";
import { CURRENT_COUNTRY, HAS_ZOEY_COUNTRY } from "src/constants/Countries";
import { V2_URL } from "src/constants/url.constants";

type Props = { isClickable?: boolean; customClick?: () => void; rediectToWebFlow?: boolean };

const Logo = ({ isClickable = true, customClick, rediectToWebFlow = false }: Props) => {
  const isMobile = useBreakpointValue([true, null, false], { ssr: false });
  const { data: session } = useSession();
  const logoSize = isMobile ? 24 : 28;

  const handleClickLogo = () => {
    if (!isClickable) {
      return;
    }

    if (customClick) {
      customClick();
      return;
    }

    if (session?.user) {
      Router.push(V2_URL);
    } else if (rediectToWebFlow) {
      Router.push(config.WEBFLOW_URLS[CURRENT_COUNTRY]);
    }
  };

  return (
    <Box id="logo" onClick={handleClickLogo} cursor="pointer">
      {HAS_ZOEY_COUNTRY ? <LogoOfNoahZoey height={logoSize} /> : <LogoOfNoah height={logoSize} />}
    </Box>
  );
};

export default Logo;
